import { motion } from 'framer-motion';
import React, { FC, useState, useEffect } from 'react';

interface PaymentsPopupInterface {
  images: string[];
  region: string | undefined;
}

const PaymentsPopup: FC<PaymentsPopupInterface> = ({ images, region}) => {
const [isGallery, setIsGallery] = useState<boolean>(true)

const southeastAsia = region === 'Southeast Asia'

  useEffect(() => {
    if (images.length > 2) {
        setIsGallery(true)
    } else {
      setIsGallery(false)
    };
  },[images.length]);

  return (
    <motion.div
      initial={{
        opacity: 0,
        scale: 0
      }}
      animate={{
        opacity: 1,
        scale: 1
      }}
      exit={{
        opacity: 0,
        scale: 0
      }}
      transition={{
        duration: 0.5
      }}
      className={region === 'Southeast Asia' ? 'payments-popup-container wide-container' : 'payments-popup-container'}
    >
      <div className='title-box'>
        <h2 className="payments-popup-title">{region}</h2>
        <div className="payments-popup-subtitle">We support these payment methods:</div>
      </div>
      <div className={
        isGallery && !southeastAsia ? 'payments-methods-img-box' :
          isGallery && southeastAsia ? 'five-item-box' :
        ''
      }>
        {images.map((image, i) => (
          <div key={i} className='payment-provider'>
            <img src={image} alt="payments"/>
          </div>
        ))}
      </div>
      {/*<div className="arrow-bottom"/>*/}
    </motion.div>
  );
};

export default PaymentsPopup;
